import { SxProps } from '@mui/material';

import { useMytaverse } from '@providers/MytaverseProvider';
import { colors } from '@constants/colors';
import { ScreenSizes } from '@interfaces';
import { useTheme } from '@mui/material/styles';

export const useStyles = () => {
  const { appTheme } = useMytaverse();
  const { breakpoints } = useTheme();
  const {
    submitButton: { backgroundColorHover },
  } = appTheme.avatarPage.assets;

  return {
    root: {
      '& .MuiBackdrop-root': {
        backgroundColor: '#00000066',
        backdropFilter: ' blur(12px)',
      },
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '24px 32px 28px',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 460,
      background: colors.white,
      borderRadius: '16px',
      boxShadow: 24,

      '&:focus-visible': {
        outline: 'none',
      },

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        padding: '20px 24px',
        width: '90%',
        maxWidth: 420,
      },
    } as SxProps,
    iconContainer: {
      display: 'flex',
      background: appTheme.mainColor,
      borderRadius: '50%',
      padding: 0.75,
      '& svg': {
        color: colors.white,
        width: 18,
        height: 18,
      },
    },
    title: {
      fontFamily: 'Primary-Medium',
      fontSize: 20,
      lineHeight: 1.3,
      color: colors.black,
      marginTop: 0.75,
      textAlign: 'center',
    },
    subtitle: {
      fontFamily: 'Primary-Medium',
      fontSize: 14,
      lineHeight: 1.4,
      color: colors.black,
      marginTop: 0.25,
      textAlign: 'center',
      opacity: 0.7,
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      width: '100%',
      marginTop: 2,
    },
    input: {
      '& .MuiOutlinedInput-root': {
        borderRadius: '8px',
        fontSize: 14,
        fontFamily: 'Primary-Medium',
        '& .MuiInputLabel-root': {
          fontFamily: 'Primary-Medium',
          fontSize: 14,
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: appTheme.mainColor,
          borderWidth: 2,
        },
      },
    },
    genderLabel: {
      fontFamily: 'Primary-Medium',
      fontSize: 14,
      color: 'rgba(0, 0, 0, 0.6)',
      marginBottom: 0.5,
      display: 'block',
    },
    formControl: {
      width: '100%',
      alignItems: 'flex-start',
    },
    radioGroup: {
      flexDirection: 'row',
      gap: 2,
      justifyContent: 'flex-start',
      '& .MuiFormControlLabel-label': {
        fontFamily: 'Primary-Medium',
        fontSize: 14,
      },
    },
    radio: {
      color: appTheme.mainColor,
      '&.Mui-checked': {
        color: appTheme.mainColor,
      },
    },
    button: {
      padding: '10px 24px',
      width: '100%',
      fontFamily: 'Primary-Medium',
      fontWeight: 500,
      borderRadius: '8px',
      fontSize: 14,
      color: colors.white,
      backgroundColor: appTheme.mainColor,
      textTransform: 'none',
      marginTop: 0.5,

      '&:hover': {
        backgroundColor: backgroundColorHover,
      },

      '&:disabled': {
        color: colors.white,
        background: colors.grey_third,
        cursor: 'no-drop',
      },
    },
  };
};
